export const scrollToElement = (
  ref: React.RefObject<HTMLElement | null>,
  isMobile: boolean,
  focusSelector?: string,
  offset = 20
) => {
  if (!isMobile) return;

  const element = ref.current;
  if (!element) return;

  const rect = element.getBoundingClientRect();
  const scrollTop = window.scrollY + rect.bottom - window.innerHeight + offset;

  window.scrollTo({ top: scrollTop, behavior: 'smooth' });

  setTimeout(() => {
    const target = focusSelector
      ? document.querySelector<HTMLButtonElement>(focusSelector)
      : (element as HTMLButtonElement);
    target?.focus();
  }, 500);
};

export const scrollToSidDeviceLinkBox = (
  ref: React.RefObject<HTMLDivElement | null>,
  isMobile: boolean
) => {
  scrollToElement(ref, isMobile, 'button[data-testid="deviceLinkBtn"]');
};

export const scrollToSidNotificationBox = (
  ref: React.RefObject<HTMLButtonElement | null>,
  isMobile: boolean
) => {
  scrollToElement(ref, isMobile, undefined);
}

export const scrollToMidContinue = (
  ref: React.RefObject<HTMLButtonElement | null>,
  isMobile: boolean
) => {
  scrollToElement(ref, isMobile, undefined);
}

export const scrollToEpsUtil = (
  ref: React.RefObject<HTMLDivElement | null>,
  isMobile: boolean
) => {
  scrollToElement(ref, isMobile, 'button[data-testid="epsStartBtn"]');
}